<template>
  <v-app id="vuetify-app">
    <v-container fluid>
      <v-layout align-center justify-center row fill-height>
        <v-flex xs12 md4>
          <v-card>
            <v-card-title>
              <h3>
                {{ `app.reset_password` | trans }}
              </h3>
            </v-card-title>
            <v-card-text>
              <v-alert :value="passwordSetSuccessful" type="success">
                {{ `passwords.reset` | trans }}
              </v-alert>
              <v-form v-if="!passwordSetSuccessful" v-model="formValid" lazy-validation ref="setPasswordForm">
                <v-text-field
                    v-model="userData.email"
                    type="email"
                    required
                    :rules="rules.email"
                    :label="`app.email` | trans"
                ></v-text-field>
                <v-text-field
                    v-model="userData.password"
                    type="password"
                    required
                    :rules="rules.password"
                    :label="`app.password` | trans"
                ></v-text-field>
                <v-text-field
                    v-model="userData.password_confirmation"
                    type="password"
                    required
                    :rules="rules.password_confirmation"
                    :label="`app.password_confirmation` | trans"
                ></v-text-field>
                <v-btn :disabled="!formValid || loading" :loading="loading" color="primary" type="submit"
                       @click="resetPassword">{{ `app.reset_password` | trans }}
                </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import RulesBuilder from "../../utils/rulesBuilder";
import {trans} from "../../app";
import {platform} from "../../utils/platform";

export default {
  props: {
    email: String,
    token: String,
    routes: Object,
  },
  data() {
    return {
      loading: false,
      formValid: false,
      userData: {
        email: "",
        password: "",
        password_confirmation: "",
      },
      rulesBuilder: new RulesBuilder(),
      passwordSetSuccessful: false,
    };
  },
  mounted() {
    this.userData.email = this.email;
  },
  computed: {
    rules() {
      return {
        email: this.rulesBuilder.addRequiredRule(trans('app.email'))
            .addMaxLengthRule(trans('app.email'), 255)
            .getRules(),
        password: this.rulesBuilder.addRequiredRule(trans('app.password'))
            .addMinLengthRule(trans('app.password'), 8)
            .getRules(),
        password_confirmation: this.rulesBuilder.addRequiredRule(trans('app.password_confirmation'))
            .addMinLengthRule(trans('app.password'), 8)
            .addSameRule(trans('app.password'), trans('app.password_confirmation'), this.userData.password)
            .getRules(),
      }
    }
  },
  methods: {
    resetPassword() {
      this.loading = true;

      if (this.$refs.setPasswordForm.validate() === false) {
        this.loading = false;
        this.$toast.error(trans('app.mobile_app.password_reset.password_set_failed'));
        return;
      }
      axios.post(this.routes.set_password, {
        email: this.userData.email,
        password: this.userData.password,
        password_confirmation: this.userData.password_confirmation,
        token: this.token,
        device: platform()
      }).then((response) => {
        const redirect = response.data.redirect;
        this.passwordSetSuccessful = true;
        if (redirect !== '') {
          window.location.href = redirect;
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$toast.error(trans('app.mobile_app.password_reset.password_set_failed'));
      })
    }
  }
};
</script>
<style scoped>
</style>
